// extracted by mini-css-extract-plugin
export var closeButton = "_fp-2";
export var closeButtonIcon = "_fp-3";
export var lightboxContent = "_fp-1";
export var lightboxOverlay = "_fp-0";